import { For, RadioGroup, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveUser } from '@redux/authent/authent.selectors';
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from '@redux/settings/settings.reducer';
import { selectLanguage } from '@redux/settings/settings.selectors';
import { usePatchLanguageMutation } from '@services/config/setting.api';
import { FormattedMessage } from 'react-intl';

export default function LanguageSettings() {
  const { login } = useAppSelector(selectActiveUser);
  const language = useAppSelector(selectLanguage);

  const [patchLanguage] = usePatchLanguageMutation();

  const handleLanguage = (language: string) => {
    patchLanguage({ login, language });
  };

  return (
    <VStack backgroundColor="neutral.800" flexShrink={0} gap={4} padding={4} alignItems="start" height="100%">
      <Text fontSize="22px">
        <FormattedMessage id="components.userSettings.language.title" />
      </Text>
      <RadioGroup.Root
        data-group
        value={language}
        onValueChange={({ value }) => handleLanguage(value ?? DEFAULT_LANGUAGE)}
      >
        <For each={Object.keys(AVAILABLE_LANGUAGES)}>
          {(item) => (
            <RadioGroup.Item key={item} value={item}>
              <RadioGroup.ItemIndicator />
              <RadioGroup.ItemHiddenInput />
              <RadioGroup.ItemText>
                <FormattedMessage id={`components.userSettings.language.${item}`} />
              </RadioGroup.ItemText>
            </RadioGroup.Item>
          )}
        </For>
      </RadioGroup.Root>
    </VStack>
  );
}
